module.exports = __webpack_public_path__ + "img/Gastronomía.f0653ad6.png";